var _desc, _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-16 -32 880 192",
    width: 880,
    height: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with https://github.com/Platane/snk")), _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root{--cb:#1b1f230a;--cs:purple;--ce:#ebedf0;--c0:#ebedf0;--c1:#9be9a8;--c2:#40c463;--c3:#30a14e;--c4:#216e39}.c{shape-rendering:geometricPrecision;fill:var(--ce);stroke-width:1px;stroke:var(--cb);animation:none 62700ms linear infinite;width:12px;height:12px}@keyframes c0{0.31%{fill:var(--c1)}0.33%,100%{fill:var(--ce)}}.c.c0{fill:var(--c1);animation-name:c0}@keyframes c1{52.78%{fill:var(--c2)}52.8%,100%{fill:var(--ce)}}.c.c1{fill:var(--c2);animation-name:c1}@keyframes c2{53.1%{fill:var(--c2)}53.12%,100%{fill:var(--ce)}}.c.c2{fill:var(--c2);animation-name:c2}@keyframes c3{4.14%{fill:var(--c1)}4.16%,100%{fill:var(--ce)}}.c.c3{fill:var(--c1);animation-name:c3}@keyframes c4{4.3%{fill:var(--c1)}4.32%,100%{fill:var(--ce)}}.c.c4{fill:var(--c1);animation-name:c4}@keyframes c5{83.24%{fill:var(--c3)}83.26%,100%{fill:var(--ce)}}.c.c5{fill:var(--c3);animation-name:c5}@keyframes c6{83.08%{fill:var(--c3)}83.1%,100%{fill:var(--ce)}}.c.c6{fill:var(--c3);animation-name:c6}@keyframes c7{52.62%{fill:var(--c2)}52.64%,100%{fill:var(--ce)}}.c.c7{fill:var(--c2);animation-name:c7}@keyframes c8{1.11%{fill:var(--c1)}1.13%,100%{fill:var(--ce)}}.c.c8{fill:var(--c1);animation-name:c8}@keyframes c9{53.26%{fill:var(--c2)}53.28%,100%{fill:var(--ce)}}.c.c9{fill:var(--c2);animation-name:c9}@keyframes ca{1.58%{fill:var(--c1)}1.6%,100%{fill:var(--ce)}}.c.ca{fill:var(--c1);animation-name:ca}@keyframes cb{1.43%{fill:var(--c1)}1.45%,100%{fill:var(--ce)}}.c.cb{fill:var(--c1);animation-name:cb}@keyframes cc{1.27%{fill:var(--c1)}1.29%,100%{fill:var(--ce)}}.c.cc{fill:var(--c1);animation-name:cc}@keyframes cd{82.45%{fill:var(--c3)}82.47%,100%{fill:var(--ce)}}.c.cd{fill:var(--c3);animation-name:cd}@keyframes ce{3.82%{fill:var(--c1)}3.84%,100%{fill:var(--ce)}}.c.ce{fill:var(--c1);animation-name:ce}@keyframes cf{3.66%{fill:var(--c1)}3.68%,100%{fill:var(--ce)}}.c.cf{fill:var(--c1);animation-name:cf}@keyframes cg{1.74%{fill:var(--c1)}1.76%,100%{fill:var(--ce)}}.c.cg{fill:var(--c1);animation-name:cg}@keyframes ch{51.19%{fill:var(--c2)}51.21%,100%{fill:var(--ce)}}.c.ch{fill:var(--c2);animation-name:ch}@keyframes ci{86.43%{fill:var(--c4)}86.45%,100%{fill:var(--ce)}}.c.ci{fill:var(--c4);animation-name:ci}@keyframes cj{86.59%{fill:var(--c4)}86.61%,100%{fill:var(--ce)}}.c.cj{fill:var(--c4);animation-name:cj}@keyframes ck{81.97%{fill:var(--c3)}81.99%,100%{fill:var(--ce)}}.c.ck{fill:var(--c3);animation-name:ck}@keyframes cl{87.55%{fill:var(--c4)}87.57%,100%{fill:var(--ce)}}.c.cl{fill:var(--c4);animation-name:cl}@keyframes cm{50.71%{fill:var(--c2)}50.73%,100%{fill:var(--ce)}}.c.cm{fill:var(--c2);animation-name:cm}@keyframes cn{2.06%{fill:var(--c1)}2.08%,100%{fill:var(--ce)}}.c.cn{fill:var(--c1);animation-name:cn}@keyframes co{2.54%{fill:var(--c1)}2.56%,100%{fill:var(--ce)}}.c.co{fill:var(--c1);animation-name:co}@keyframes cp{2.7%{fill:var(--c1)}2.72%,100%{fill:var(--ce)}}.c.cp{fill:var(--c1);animation-name:cp}@keyframes cq{2.86%{fill:var(--c1)}2.88%,100%{fill:var(--ce)}}.c.cq{fill:var(--c1);animation-name:cq}@keyframes cr{50.55%{fill:var(--c2)}50.57%,100%{fill:var(--ce)}}.c.cr{fill:var(--c2);animation-name:cr}@keyframes cs{2.22%{fill:var(--c1)}2.24%,100%{fill:var(--ce)}}.c.cs{fill:var(--c1);animation-name:cs}@keyframes ct{2.38%{fill:var(--c1)}2.4%,100%{fill:var(--ce)}}.c.ct{fill:var(--c1);animation-name:ct}@keyframes cu{51.66%{fill:var(--c2)}51.68%,100%{fill:var(--ce)}}.c.cu{fill:var(--c2);animation-name:cu}@keyframes cv{81.49%{fill:var(--c3)}81.51%,100%{fill:var(--ce)}}.c.cv{fill:var(--c3);animation-name:cv}@keyframes cw{45.6%{fill:var(--c2)}45.62%,100%{fill:var(--ce)}}.c.cw{fill:var(--c2);animation-name:cw}@keyframes cx{45.44%{fill:var(--c1)}45.46%,100%{fill:var(--ce)}}.c.cx{fill:var(--c1);animation-name:cx}@keyframes cy{45.29%{fill:var(--c1)}45.31%,100%{fill:var(--ce)}}.c.cy{fill:var(--c1);animation-name:cy}@keyframes cz{16.58%{fill:var(--c1)}16.6%,100%{fill:var(--ce)}}.c.cz{fill:var(--c1);animation-name:cz}@keyframes c10{45.76%{fill:var(--c2)}45.78%,100%{fill:var(--ce)}}.c.c10{fill:var(--c2);animation-name:c10}@keyframes c11{85.8%{fill:var(--c4)}85.82%,100%{fill:var(--ce)}}.c.c11{fill:var(--c4);animation-name:c11}@keyframes c12{81.17%{fill:var(--c3)}81.19%,100%{fill:var(--ce)}}.c.c12{fill:var(--c3);animation-name:c12}@keyframes c13{16.1%{fill:var(--c1)}16.12%,100%{fill:var(--ce)}}.c.c13{fill:var(--c1);animation-name:c13}@keyframes c14{15.94%{fill:var(--c1)}15.96%,100%{fill:var(--ce)}}.c.c14{fill:var(--c1);animation-name:c14}@keyframes c15{16.74%{fill:var(--c1)}16.76%,100%{fill:var(--ce)}}.c.c15{fill:var(--c1);animation-name:c15}@keyframes c16{80.69%{fill:var(--c3)}80.71%,100%{fill:var(--ce)}}.c.c16{fill:var(--c3);animation-name:c16}@keyframes c17{18.01%{fill:var(--c1)}18.03%,100%{fill:var(--ce)}}.c.c17{fill:var(--c1);animation-name:c17}@keyframes c18{18.17%{fill:var(--c1)}18.19%,100%{fill:var(--ce)}}.c.c18{fill:var(--c1);animation-name:c18}@keyframes c19{85.32%{fill:var(--c3)}85.34%,100%{fill:var(--ce)}}.c.c19{fill:var(--c3);animation-name:c19}@keyframes c1a{46.56%{fill:var(--c2)}46.58%,100%{fill:var(--ce)}}.c.c1a{fill:var(--c2);animation-name:c1a}@keyframes c1b{15.78%{fill:var(--c1)}15.8%,100%{fill:var(--ce)}}.c.c1b{fill:var(--c1);animation-name:c1b}@keyframes c1c{46.24%{fill:var(--c2)}46.26%,100%{fill:var(--ce)}}.c.c1c{fill:var(--c2);animation-name:c1c}@keyframes c1d{6.85%{fill:var(--c1)}6.87%,100%{fill:var(--ce)}}.c.c1d{fill:var(--c1);animation-name:c1d}@keyframes c1e{6.53%{fill:var(--c1)}6.55%,100%{fill:var(--ce)}}.c.c1e{fill:var(--c1);animation-name:c1e}@keyframes c1f{49.27%{fill:var(--c2)}49.29%,100%{fill:var(--ce)}}.c.c1f{fill:var(--c2);animation-name:c1f}@keyframes c1g{6.21%{fill:var(--c1)}6.23%,100%{fill:var(--ce)}}.c.c1g{fill:var(--c1);animation-name:c1g}@keyframes c1h{15.3%{fill:var(--c1)}15.32%,100%{fill:var(--ce)}}.c.c1h{fill:var(--c1);animation-name:c1h}@keyframes c1i{7.33%{fill:var(--c1)}7.35%,100%{fill:var(--ce)}}.c.c1i{fill:var(--c1);animation-name:c1i}@keyframes c1j{7.49%{fill:var(--c1)}7.51%,100%{fill:var(--ce)}}.c.c1j{fill:var(--c1);animation-name:c1j}@keyframes c1k{48.79%{fill:var(--c2)}48.81%,100%{fill:var(--ce)}}.c.c1k{fill:var(--c2);animation-name:c1k}@keyframes c1l{47.36%{fill:var(--c2)}47.38%,100%{fill:var(--ce)}}.c.c1l{fill:var(--c2);animation-name:c1l}@keyframes c1m{47.68%{fill:var(--c2)}47.7%,100%{fill:var(--ce)}}.c.c1m{fill:var(--c2);animation-name:c1m}@keyframes c1n{8.28%{fill:var(--c1)}8.3%,100%{fill:var(--ce)}}.c.c1n{fill:var(--c1);animation-name:c1n}@keyframes c1o{8.12%{fill:var(--c1)}8.14%,100%{fill:var(--ce)}}.c.c1o{fill:var(--c1);animation-name:c1o}@keyframes c1p{7.96%{fill:var(--c1)}7.98%,100%{fill:var(--ce)}}.c.c1p{fill:var(--c1);animation-name:c1p}@keyframes c1q{14.18%{fill:var(--c1)}14.2%,100%{fill:var(--ce)}}.c.c1q{fill:var(--c1);animation-name:c1q}@keyframes c1r{8.76%{fill:var(--c1)}8.78%,100%{fill:var(--ce)}}.c.c1r{fill:var(--c1);animation-name:c1r}@keyframes c1s{13.87%{fill:var(--c1)}13.89%,100%{fill:var(--ce)}}.c.c1s{fill:var(--c1);animation-name:c1s}@keyframes c1t{8.92%{fill:var(--c1)}8.94%,100%{fill:var(--ce)}}.c.c1t{fill:var(--c1);animation-name:c1t}@keyframes c1u{9.08%{fill:var(--c1)}9.1%,100%{fill:var(--ce)}}.c.c1u{fill:var(--c1);animation-name:c1u}@keyframes c1v{12.75%{fill:var(--c1)}12.77%,100%{fill:var(--ce)}}.c.c1v{fill:var(--c1);animation-name:c1v}@keyframes c1w{13.39%{fill:var(--c1)}13.41%,100%{fill:var(--ce)}}.c.c1w{fill:var(--c1);animation-name:c1w}@keyframes c1x{12.43%{fill:var(--c1)}12.45%,100%{fill:var(--ce)}}.c.c1x{fill:var(--c1);animation-name:c1x}@keyframes c1y{12.27%{fill:var(--c1)}12.29%,100%{fill:var(--ce)}}.c.c1y{fill:var(--c1);animation-name:c1y}@keyframes c1z{9.56%{fill:var(--c1)}9.58%,100%{fill:var(--ce)}}.c.c1z{fill:var(--c1);animation-name:c1z}@keyframes c20{10.04%{fill:var(--c1)}10.06%,100%{fill:var(--ce)}}.c.c20{fill:var(--c1);animation-name:c20}@keyframes c21{11.63%{fill:var(--c1)}11.65%,100%{fill:var(--ce)}}.c.c21{fill:var(--c1);animation-name:c21}@keyframes c22{11.31%{fill:var(--c1)}11.33%,100%{fill:var(--ce)}}.c.c22{fill:var(--c1);animation-name:c22}@keyframes c23{10.52%{fill:var(--c1)}10.54%,100%{fill:var(--ce)}}.c.c23{fill:var(--c1);animation-name:c23}@keyframes c24{57.41%{fill:var(--c2)}57.43%,100%{fill:var(--ce)}}.c.c24{fill:var(--c2);animation-name:c24}@keyframes c25{22%{fill:var(--c1)}22.02%,100%{fill:var(--ce)}}.c.c25{fill:var(--c1);animation-name:c25}@keyframes c26{58.52%{fill:var(--c2)}58.54%,100%{fill:var(--ce)}}.c.c26{fill:var(--c2);animation-name:c26}@keyframes c27{25.67%{fill:var(--c1)}25.69%,100%{fill:var(--ce)}}.c.c27{fill:var(--c1);animation-name:c27}@keyframes c28{22.16%{fill:var(--c1)}22.18%,100%{fill:var(--ce)}}.c.c28{fill:var(--c1);animation-name:c28}@keyframes c29{22.32%{fill:var(--c1)}22.34%,100%{fill:var(--ce)}}.c.c29{fill:var(--c1);animation-name:c29}@keyframes c2a{25.51%{fill:var(--c1)}25.53%,100%{fill:var(--ce)}}.c.c2a{fill:var(--c1);animation-name:c2a}@keyframes c2b{26.47%{fill:var(--c1)}26.49%,100%{fill:var(--ce)}}.c.c2b{fill:var(--c1);animation-name:c2b}@keyframes c2c{61.07%{fill:var(--c2)}61.09%,100%{fill:var(--ce)}}.c.c2c{fill:var(--c2);animation-name:c2c}@keyframes c2d{59.16%{fill:var(--c2)}59.18%,100%{fill:var(--ce)}}.c.c2d{fill:var(--c2);animation-name:c2d}@keyframes c2e{22.64%{fill:var(--c1)}22.66%,100%{fill:var(--ce)}}.c.c2e{fill:var(--c1);animation-name:c2e}@keyframes c2f{26.62%{fill:var(--c1)}26.64%,100%{fill:var(--ce)}}.c.c2f{fill:var(--c1);animation-name:c2f}@keyframes c2g{59.96%{fill:var(--c2)}59.98%,100%{fill:var(--ce)}}.c.c2g{fill:var(--c2);animation-name:c2g}@keyframes c2h{24.87%{fill:var(--c1)}24.89%,100%{fill:var(--ce)}}.c.c2h{fill:var(--c1);animation-name:c2h}@keyframes c2i{70.64%{fill:var(--c3)}70.66%,100%{fill:var(--ce)}}.c.c2i{fill:var(--c3);animation-name:c2i}@keyframes c2j{59.32%{fill:var(--c2)}59.34%,100%{fill:var(--ce)}}.c.c2j{fill:var(--c2);animation-name:c2j}@keyframes c2k{22.8%{fill:var(--c1)}22.82%,100%{fill:var(--ce)}}.c.c2k{fill:var(--c1);animation-name:c2k}@keyframes c2l{93.13%{fill:var(--c4)}93.15%,100%{fill:var(--ce)}}.c.c2l{fill:var(--c4);animation-name:c2l}@keyframes c2m{93.29%{fill:var(--c4)}93.31%,100%{fill:var(--ce)}}.c.c2m{fill:var(--c4);animation-name:c2m}@keyframes c2n{24.55%{fill:var(--c1)}24.57%,100%{fill:var(--ce)}}.c.c2n{fill:var(--c1);animation-name:c2n}@keyframes c2o{23.28%{fill:var(--c1)}23.3%,100%{fill:var(--ce)}}.c.c2o{fill:var(--c1);animation-name:c2o}@keyframes c2p{23.43%{fill:var(--c1)}23.45%,100%{fill:var(--ce)}}.c.c2p{fill:var(--c1);animation-name:c2p}@keyframes c2q{24.23%{fill:var(--c1)}24.25%,100%{fill:var(--ce)}}.c.c2q{fill:var(--c1);animation-name:c2q}@keyframes c2r{23.59%{fill:var(--c1)}23.61%,100%{fill:var(--ce)}}.c.c2r{fill:var(--c1);animation-name:c2r}@keyframes c2s{68.89%{fill:var(--c3)}68.91%,100%{fill:var(--ce)}}.c.c2s{fill:var(--c3);animation-name:c2s}@keyframes c2t{68.73%{fill:var(--c2)}68.75%,100%{fill:var(--ce)}}.c.c2t{fill:var(--c2);animation-name:c2t}@keyframes c2u{62.19%{fill:var(--c2)}62.21%,100%{fill:var(--ce)}}.c.c2u{fill:var(--c2);animation-name:c2u}@keyframes c2v{69.69%{fill:var(--c3)}69.71%,100%{fill:var(--ce)}}.c.c2v{fill:var(--c3);animation-name:c2v}@keyframes c2w{67.61%{fill:var(--c2)}67.63%,100%{fill:var(--ce)}}.c.c2w{fill:var(--c2);animation-name:c2w}@keyframes c2x{27.9%{fill:var(--c1)}27.92%,100%{fill:var(--ce)}}.c.c2x{fill:var(--c1);animation-name:c2x}@keyframes c2y{67.29%{fill:var(--c2)}67.31%,100%{fill:var(--ce)}}.c.c2y{fill:var(--c2);animation-name:c2y}@keyframes c2z{39.38%{fill:var(--c1)}39.4%,100%{fill:var(--ce)}}.c.c2z{fill:var(--c1);animation-name:c2z}@keyframes c30{28.7%{fill:var(--c1)}28.72%,100%{fill:var(--ce)}}.c.c30{fill:var(--c1);animation-name:c30}@keyframes c31{28.54%{fill:var(--c1)}28.56%,100%{fill:var(--ce)}}.c.c31{fill:var(--c1);animation-name:c31}@keyframes c32{28.38%{fill:var(--c1)}28.4%,100%{fill:var(--ce)}}.c.c32{fill:var(--c1);animation-name:c32}@keyframes c33{28.22%{fill:var(--c1)}28.24%,100%{fill:var(--ce)}}.c.c33{fill:var(--c1);animation-name:c33}@keyframes c34{38.91%{fill:var(--c1)}38.93%,100%{fill:var(--ce)}}.c.c34{fill:var(--c1);animation-name:c34}@keyframes c35{62.67%{fill:var(--c2)}62.69%,100%{fill:var(--ce)}}.c.c35{fill:var(--c2);animation-name:c35}@keyframes c36{33.16%{fill:var(--c1)}33.18%,100%{fill:var(--ce)}}.c.c36{fill:var(--c1);animation-name:c36}@keyframes c37{33.32%{fill:var(--c1)}33.34%,100%{fill:var(--ce)}}.c.c37{fill:var(--c1);animation-name:c37}@keyframes c38{32.53%{fill:var(--c1)}32.55%,100%{fill:var(--ce)}}.c.c38{fill:var(--c1);animation-name:c38}@keyframes c39{32.84%{fill:var(--c1)}32.86%,100%{fill:var(--ce)}}.c.c39{fill:var(--c1);animation-name:c39}@keyframes c3a{33%{fill:var(--c1)}33.02%,100%{fill:var(--ce)}}.c.c3a{fill:var(--c1);animation-name:c3a}@keyframes c3b{33.48%{fill:var(--c1)}33.5%,100%{fill:var(--ce)}}.c.c3b{fill:var(--c1);animation-name:c3b}@keyframes c3c{29.5%{fill:var(--c1)}29.52%,100%{fill:var(--ce)}}.c.c3c{fill:var(--c1);animation-name:c3c}@keyframes c3d{32.21%{fill:var(--c1)}32.23%,100%{fill:var(--ce)}}.c.c3d{fill:var(--c1);animation-name:c3d}@keyframes c3e{63.15%{fill:var(--c2)}63.17%,100%{fill:var(--ce)}}.c.c3e{fill:var(--c2);animation-name:c3e}@keyframes c3f{29.81%{fill:var(--c1)}29.83%,100%{fill:var(--ce)}}.c.c3f{fill:var(--c1);animation-name:c3f}@keyframes c3g{32.05%{fill:var(--c1)}32.07%,100%{fill:var(--ce)}}.c.c3g{fill:var(--c1);animation-name:c3g}@keyframes c3h{33.96%{fill:var(--c1)}33.98%,100%{fill:var(--ce)}}.c.c3h{fill:var(--c1);animation-name:c3h}@keyframes c3i{33.8%{fill:var(--c1)}33.82%,100%{fill:var(--ce)}}.c.c3i{fill:var(--c1);animation-name:c3i}@keyframes c3j{63.31%{fill:var(--c2)}63.33%,100%{fill:var(--ce)}}.c.c3j{fill:var(--c2);animation-name:c3j}@keyframes c3k{29.97%{fill:var(--c1)}29.99%,100%{fill:var(--ce)}}.c.c3k{fill:var(--c1);animation-name:c3k}@keyframes c3l{30.13%{fill:var(--c1)}30.15%,100%{fill:var(--ce)}}.c.c3l{fill:var(--c1);animation-name:c3l}@keyframes c3m{30.29%{fill:var(--c1)}30.31%,100%{fill:var(--ce)}}.c.c3m{fill:var(--c1);animation-name:c3m}@keyframes c3n{31.73%{fill:var(--c1)}31.75%,100%{fill:var(--ce)}}.c.c3n{fill:var(--c1);animation-name:c3n}@keyframes c3o{31.09%{fill:var(--c1)}31.11%,100%{fill:var(--ce)}}.c.c3o{fill:var(--c1);animation-name:c3o}@keyframes c3p{30.61%{fill:var(--c1)}30.63%,100%{fill:var(--ce)}}.c.c3p{fill:var(--c1);animation-name:c3p}@keyframes c3q{30.45%{fill:var(--c1)}30.47%,100%{fill:var(--ce)}}.c.c3q{fill:var(--c1);animation-name:c3q}@keyframes c3r{31.57%{fill:var(--c1)}31.59%,100%{fill:var(--ce)}}.c.c3r{fill:var(--c1);animation-name:c3r}@keyframes c3s{34.6%{fill:var(--c1)}34.62%,100%{fill:var(--ce)}}.c.c3s{fill:var(--c1);animation-name:c3s}@keyframes c3t{34.44%{fill:var(--c1)}34.46%,100%{fill:var(--ce)}}.c.c3t{fill:var(--c1);animation-name:c3t}@keyframes c3u{30.93%{fill:var(--c1)}30.95%,100%{fill:var(--ce)}}.c.c3u{fill:var(--c1);animation-name:c3u}@keyframes c3v{30.77%{fill:var(--c1)}30.79%,100%{fill:var(--ce)}}.c.c3v{fill:var(--c1);animation-name:c3v}@keyframes c3w{35.24%{fill:var(--c1)}35.26%,100%{fill:var(--ce)}}.c.c3w{fill:var(--c1);animation-name:c3w}@keyframes c3x{35.56%{fill:var(--c1)}35.58%,100%{fill:var(--ce)}}.c.c3x{fill:var(--c1);animation-name:c3x}@keyframes c3y{64.42%{fill:var(--c2)}64.44%,100%{fill:var(--ce)}}.c.c3y{fill:var(--c2);animation-name:c3y}@keyframes c3z{64.58%{fill:var(--c2)}64.6%,100%{fill:var(--ce)}}.c.c3z{fill:var(--c2);animation-name:c3z}@keyframes c40{73.67%{fill:var(--c3)}73.69%,100%{fill:var(--ce)}}.c.c40{fill:var(--c3);animation-name:c40}@keyframes c41{65.22%{fill:var(--c2)}65.24%,100%{fill:var(--ce)}}.c.c41{fill:var(--c2);animation-name:c41}@keyframes c42{36.99%{fill:var(--c1)}37.01%,100%{fill:var(--ce)}}.c.c42{fill:var(--c1);animation-name:c42}@keyframes c43{64.9%{fill:var(--c2)}64.92%,100%{fill:var(--ce)}}.c.c43{fill:var(--c2);animation-name:c43}@keyframes c44{36.67%{fill:var(--c1)}36.69%,100%{fill:var(--ce)}}.c.c44{fill:var(--c1);animation-name:c44}.u{transform-origin:0 0;transform:scale(0,1);animation:none linear 62700ms infinite}@keyframes u0{0.31%{transform:scale(0.000,1)}0.33%,1.11%{transform:scale(0.010,1)}1.13%,1.27%{transform:scale(0.020,1)}1.29%,1.43%{transform:scale(0.031,1)}1.45%,1.58%{transform:scale(0.041,1)}1.6%,1.74%{transform:scale(0.051,1)}1.76%,2.06%{transform:scale(0.061,1)}2.08%,2.22%{transform:scale(0.071,1)}2.24%,2.38%{transform:scale(0.082,1)}2.4%,2.54%{transform:scale(0.092,1)}2.56%,2.7%{transform:scale(0.102,1)}2.72%,2.86%{transform:scale(0.112,1)}2.88%,3.66%{transform:scale(0.122,1)}3.68%,3.82%{transform:scale(0.133,1)}3.84%,4.14%{transform:scale(0.143,1)}4.16%,4.3%{transform:scale(0.153,1)}4.32%,6.21%{transform:scale(0.163,1)}6.23%,6.53%{transform:scale(0.173,1)}6.55%,6.85%{transform:scale(0.184,1)}6.87%,7.33%{transform:scale(0.194,1)}7.35%,7.49%{transform:scale(0.204,1)}7.51%,7.96%{transform:scale(0.214,1)}7.98%,8.12%{transform:scale(0.224,1)}8.14%,8.28%{transform:scale(0.235,1)}8.3%,8.76%{transform:scale(0.245,1)}8.78%,8.92%{transform:scale(0.255,1)}8.94%,9.08%{transform:scale(0.265,1)}9.1%,9.56%{transform:scale(0.276,1)}9.58%,10.04%{transform:scale(0.286,1)}10.06%,10.52%{transform:scale(0.296,1)}10.54%,11.31%{transform:scale(0.306,1)}11.33%,11.63%{transform:scale(0.316,1)}11.65%,12.27%{transform:scale(0.327,1)}12.29%,12.43%{transform:scale(0.337,1)}12.45%,12.75%{transform:scale(0.347,1)}12.77%,13.39%{transform:scale(0.357,1)}13.41%,13.87%{transform:scale(0.367,1)}13.89%,14.18%{transform:scale(0.378,1)}14.2%,15.3%{transform:scale(0.388,1)}15.32%,15.78%{transform:scale(0.398,1)}15.8%,15.94%{transform:scale(0.408,1)}15.96%,16.1%{transform:scale(0.418,1)}16.12%,16.58%{transform:scale(0.429,1)}16.6%,16.74%{transform:scale(0.439,1)}16.76%,18.01%{transform:scale(0.449,1)}18.03%,18.17%{transform:scale(0.459,1)}18.19%,22%{transform:scale(0.469,1)}22.02%,22.16%{transform:scale(0.480,1)}22.18%,22.32%{transform:scale(0.490,1)}22.34%,22.64%{transform:scale(0.500,1)}22.66%,22.8%{transform:scale(0.510,1)}22.82%,23.28%{transform:scale(0.520,1)}23.3%,23.43%{transform:scale(0.531,1)}23.45%,23.59%{transform:scale(0.541,1)}23.61%,24.23%{transform:scale(0.551,1)}24.25%,24.55%{transform:scale(0.561,1)}24.57%,24.87%{transform:scale(0.571,1)}24.89%,25.51%{transform:scale(0.582,1)}25.53%,25.67%{transform:scale(0.592,1)}25.69%,26.47%{transform:scale(0.602,1)}26.49%,26.62%{transform:scale(0.612,1)}26.64%,27.9%{transform:scale(0.622,1)}27.92%,28.22%{transform:scale(0.633,1)}28.24%,28.38%{transform:scale(0.643,1)}28.4%,28.54%{transform:scale(0.653,1)}28.56%,28.7%{transform:scale(0.663,1)}28.72%,29.5%{transform:scale(0.673,1)}29.52%,29.81%{transform:scale(0.684,1)}29.83%,29.97%{transform:scale(0.694,1)}29.99%,30.13%{transform:scale(0.704,1)}30.15%,30.29%{transform:scale(0.714,1)}30.31%,30.45%{transform:scale(0.724,1)}30.47%,30.61%{transform:scale(0.735,1)}30.63%,30.77%{transform:scale(0.745,1)}30.79%,30.93%{transform:scale(0.755,1)}30.95%,31.09%{transform:scale(0.765,1)}31.11%,31.57%{transform:scale(0.776,1)}31.59%,31.73%{transform:scale(0.786,1)}31.75%,32.05%{transform:scale(0.796,1)}32.07%,32.21%{transform:scale(0.806,1)}32.23%,32.53%{transform:scale(0.816,1)}32.55%,32.84%{transform:scale(0.827,1)}32.86%,33%{transform:scale(0.837,1)}33.02%,33.16%{transform:scale(0.847,1)}33.18%,33.32%{transform:scale(0.857,1)}33.34%,33.48%{transform:scale(0.867,1)}33.5%,33.8%{transform:scale(0.878,1)}33.82%,33.96%{transform:scale(0.888,1)}33.98%,34.44%{transform:scale(0.898,1)}34.46%,34.6%{transform:scale(0.908,1)}34.62%,35.24%{transform:scale(0.918,1)}35.26%,35.56%{transform:scale(0.929,1)}35.58%,36.67%{transform:scale(0.939,1)}36.69%,36.99%{transform:scale(0.949,1)}37.01%,38.91%{transform:scale(0.959,1)}38.93%,39.38%{transform:scale(0.969,1)}39.4%,45.29%{transform:scale(0.980,1)}45.31%,45.44%{transform:scale(0.990,1)}45.46%,100%{transform:scale(1.000,1)}}.u.u0{fill:var(--c1);animation-name:u0;transform-origin:0.0px 0}@keyframes u1{45.6%{transform:scale(0.000,1)}45.62%,45.76%{transform:scale(0.030,1)}45.78%,46.24%{transform:scale(0.061,1)}46.26%,46.56%{transform:scale(0.091,1)}46.58%,47.36%{transform:scale(0.121,1)}47.38%,47.68%{transform:scale(0.152,1)}47.7%,48.79%{transform:scale(0.182,1)}48.81%,49.27%{transform:scale(0.212,1)}49.29%,50.55%{transform:scale(0.242,1)}50.57%,50.71%{transform:scale(0.273,1)}50.73%,51.19%{transform:scale(0.303,1)}51.21%,51.66%{transform:scale(0.333,1)}51.68%,52.62%{transform:scale(0.364,1)}52.64%,52.78%{transform:scale(0.394,1)}52.8%,53.1%{transform:scale(0.424,1)}53.12%,53.26%{transform:scale(0.455,1)}53.28%,57.41%{transform:scale(0.485,1)}57.43%,58.52%{transform:scale(0.515,1)}58.54%,59.16%{transform:scale(0.545,1)}59.18%,59.32%{transform:scale(0.576,1)}59.34%,59.96%{transform:scale(0.606,1)}59.98%,61.07%{transform:scale(0.636,1)}61.09%,62.19%{transform:scale(0.667,1)}62.21%,62.67%{transform:scale(0.697,1)}62.69%,63.15%{transform:scale(0.727,1)}63.17%,63.31%{transform:scale(0.758,1)}63.33%,64.42%{transform:scale(0.788,1)}64.44%,64.58%{transform:scale(0.818,1)}64.6%,64.9%{transform:scale(0.848,1)}64.92%,65.22%{transform:scale(0.879,1)}65.24%,67.29%{transform:scale(0.909,1)}67.31%,67.61%{transform:scale(0.939,1)}67.63%,68.73%{transform:scale(0.970,1)}68.75%,100%{transform:scale(1.000,1)}}.u.u1{fill:var(--c2);animation-name:u1;transform-origin:557.7px 0}@keyframes u2{68.89%{transform:scale(0.000,1)}68.91%,69.69%{transform:scale(0.083,1)}69.71%,70.64%{transform:scale(0.167,1)}70.66%,73.67%{transform:scale(0.250,1)}73.69%,80.69%{transform:scale(0.333,1)}80.71%,81.17%{transform:scale(0.417,1)}81.19%,81.49%{transform:scale(0.500,1)}81.51%,81.97%{transform:scale(0.583,1)}81.99%,82.45%{transform:scale(0.667,1)}82.47%,83.08%{transform:scale(0.750,1)}83.1%,83.24%{transform:scale(0.833,1)}83.26%,85.32%{transform:scale(0.917,1)}85.34%,100%{transform:scale(1.000,1)}}.u.u2{fill:var(--c3);animation-name:u2;transform-origin:745.6px 0}@keyframes u3{85.8%{transform:scale(0.000,1)}85.82%,86.43%{transform:scale(0.167,1)}86.45%,86.59%{transform:scale(0.333,1)}86.61%,87.55%{transform:scale(0.500,1)}87.57%,93.13%{transform:scale(0.667,1)}93.15%,93.29%{transform:scale(0.833,1)}93.31%,100%{transform:scale(1.000,1)}}.u.u3{fill:var(--c4);animation-name:u3;transform-origin:813.9px 0}.s{shape-rendering:geometricPrecision;fill:var(--cs);animation:none linear 62700ms infinite}@keyframes s0{0%,99.84%{transform:translate(0px,-16px)}0.32%{transform:translate(0px,16px)}0.48%{transform:translate(-16px,16px)}0.8%{transform:translate(-16px,48px)}1.28%{transform:translate(32px,48px)}1.59%,82.93%{transform:translate(32px,16px)}1.75%,50.88%,83.73%{transform:translate(48px,16px)}1.91%{transform:translate(48px,32px)}2.23%{transform:translate(80px,32px)}2.39%,51.52%{transform:translate(80px,48px)}2.55%{transform:translate(64px,48px)}3.19%{transform:translate(64px,112px)}3.51%,4.78%{transform:translate(32px,112px)}3.83%{transform:translate(32px,80px)}4.15%{transform:translate(0px,80px)}4.31%{transform:translate(0px,96px)}4.63%,82.14%{transform:translate(32px,96px)}6.06%{transform:translate(160px,112px)}6.38%{transform:translate(160px,80px)}6.54%{transform:translate(144px,80px)}6.86%,17.7%{transform:translate(144px,48px)}7.34%{transform:translate(192px,48px)}7.5%{transform:translate(192px,64px)}7.97%{transform:translate(240px,64px)}8.29%,14.67%,47.85%{transform:translate(240px,32px)}8.45%{transform:translate(256px,32px)}8.77%{transform:translate(256px,0px)}9.89%{transform:translate(368px,0px)}10.05%{transform:translate(368px,16px)}10.37%{transform:translate(400px,16px)}10.53%{transform:translate(400px,0px)}10.69%{transform:translate(384px,0px)}11.32%{transform:translate(384px,64px)}11.48%{transform:translate(368px,64px)}11.64%{transform:translate(368px,80px)}11.8%{transform:translate(352px,80px)}11.96%{transform:translate(352px,64px)}12.28%{transform:translate(320px,64px)}12.6%{transform:translate(320px,32px)}12.76%{transform:translate(304px,32px)}13.4%{transform:translate(304px,96px)}13.88%{transform:translate(256px,96px)}14.04%{transform:translate(256px,80px)}14.19%{transform:translate(240px,80px)}15.31%{transform:translate(176px,32px)}15.47%{transform:translate(176px,16px)}15.95%,16.91%,84.53%{transform:translate(128px,16px)}16.11%{transform:translate(128px,0px)}16.27%{transform:translate(112px,0px)}16.59%,45.93%,54.55%,98.25%{transform:translate(112px,32px)}16.75%{transform:translate(128px,32px)}17.22%,49.76%{transform:translate(160px,16px)}17.54%{transform:translate(160px,48px)}17.86%{transform:translate(144px,64px)}18.02%,97.77%{transform:translate(128px,64px)}18.18%,81.02%{transform:translate(128px,80px)}18.66%,48.96%{transform:translate(176px,80px)}18.82%,49.12%{transform:translate(176px,64px)}21.69%{transform:translate(464px,64px)}21.85%{transform:translate(464px,48px)}22.17%{transform:translate(496px,48px)}22.33%{transform:translate(496px,64px)}23.13%{transform:translate(576px,64px)}23.44%{transform:translate(576px,96px)}23.6%{transform:translate(592px,96px)}24.24%{transform:translate(592px,32px)}24.56%{transform:translate(560px,32px)}24.72%{transform:translate(560px,16px)}24.88%,70.49%{transform:translate(544px,16px)}25.04%,92.34%{transform:translate(544px,0px)}25.36%{transform:translate(512px,0px)}25.52%{transform:translate(512px,16px)}25.68%{transform:translate(496px,16px)}25.84%{transform:translate(496px,32px)}26%{transform:translate(512px,32px)}26.48%,60.29%{transform:translate(512px,80px)}26.63%,60.45%{transform:translate(528px,80px)}26.79%,59.01%,59.65%{transform:translate(528px,64px)}27.59%{transform:translate(608px,64px)}27.75%{transform:translate(608px,48px)}28.23%{transform:translate(656px,48px)}28.87%{transform:translate(656px,-16px)}29.35%{transform:translate(704px,-16px)}29.67%{transform:translate(704px,16px)}29.98%{transform:translate(736px,16px)}30.14%{transform:translate(736px,32px)}30.46%{transform:translate(768px,32px)}30.62%{transform:translate(768px,16px)}30.78%{transform:translate(784px,16px)}30.94%{transform:translate(784px,0px)}31.1%{transform:translate(768px,0px)}31.58%{transform:translate(768px,48px)}32.22%{transform:translate(704px,48px)}32.38%{transform:translate(704px,32px)}32.54%{transform:translate(688px,32px)}33.01%{transform:translate(688px,80px)}33.17%{transform:translate(672px,80px)}33.33%{transform:translate(672px,96px)}33.81%{transform:translate(720px,96px)}33.97%{transform:translate(720px,80px)}34.45%{transform:translate(768px,80px)}34.61%{transform:translate(768px,64px)}34.93%,37.48%,65.55%,73.84%{transform:translate(800px,64px)}35.41%{transform:translate(800px,16px)}35.89%{transform:translate(848px,16px)}36.52%{transform:translate(848px,80px)}36.68%,65.07%{transform:translate(832px,80px)}36.84%{transform:translate(832px,96px)}37.16%{transform:translate(800px,96px)}39.07%{transform:translate(640px,64px)}39.23%{transform:translate(640px,80px)}39.39%,69.06%{transform:translate(624px,80px)}39.71%{transform:translate(624px,112px)}44.98%{transform:translate(96px,112px)}45.61%{transform:translate(96px,48px)}45.77%,54.39%,98.09%{transform:translate(112px,48px)}46.25%{transform:translate(144px,32px)}46.57%{transform:translate(144px,0px)}47.21%{transform:translate(208px,0px)}47.37%{transform:translate(208px,16px)}47.69%{transform:translate(240px,16px)}48.33%{transform:translate(192px,32px)}48.8%{transform:translate(192px,80px)}49.28%,97.45%{transform:translate(160px,64px)}51.2%{transform:translate(48px,48px)}51.67%{transform:translate(80px,64px)}51.83%{transform:translate(64px,64px)}52.15%,98.72%{transform:translate(64px,32px)}52.79%{transform:translate(0px,32px)}53.11%{transform:translate(0px,64px)}53.27%{transform:translate(16px,64px)}53.43%{transform:translate(16px,48px)}58.21%{transform:translate(480px,32px)}58.53%{transform:translate(480px,64px)}59.17%{transform:translate(528px,48px)}59.33%{transform:translate(544px,48px)}59.49%{transform:translate(544px,64px)}59.97%{transform:translate(528px,96px)}60.13%{transform:translate(512px,96px)}61.08%{transform:translate(528px,16px)}61.88%{transform:translate(608px,16px)}62.04%{transform:translate(608px,0px)}64.11%{transform:translate(816px,0px)}64.59%{transform:translate(816px,48px)}64.75%{transform:translate(832px,48px)}65.39%{transform:translate(800px,80px)}67.3%{transform:translate(624px,64px)}67.62%{transform:translate(624px,32px)}67.78%{transform:translate(640px,32px)}67.94%{transform:translate(640px,48px)}68.1%{transform:translate(624px,48px)}68.58%{transform:translate(624px,96px)}68.74%{transform:translate(608px,96px)}68.9%{transform:translate(608px,80px)}69.7%{transform:translate(624px,16px)}70.65%{transform:translate(544px,32px)}73.37%{transform:translate(816px,32px)}73.68%{transform:translate(816px,64px)}74%{transform:translate(800px,48px)}80.7%,97.93%{transform:translate(128px,48px)}81.66%,86.76%{transform:translate(64px,80px)}81.82%{transform:translate(64px,96px)}83.09%{transform:translate(16px,16px)}83.25%{transform:translate(16px,0px)}83.57%{transform:translate(48px,0px)}85.33%{transform:translate(128px,96px)}85.49%{transform:translate(112px,96px)}85.81%{transform:translate(112px,64px)}86.44%{transform:translate(48px,64px)}86.6%{transform:translate(48px,80px)}87.56%{transform:translate(64px,0px)}93.3%{transform:translate(544px,96px)}97.13%{transform:translate(160px,96px)}99.2%{transform:translate(64px,-16px)}}.s.s0{transform:translate(0px,-16px);animation-name:s0}@keyframes s1{0%,99.84%{transform:translate(16px,-16px)}0.16%{transform:translate(0px,-16px)}0.48%{transform:translate(0px,16px)}0.64%{transform:translate(-16px,16px)}0.96%{transform:translate(-16px,48px)}1.44%{transform:translate(32px,48px)}1.75%,83.09%{transform:translate(32px,16px)}1.91%,51.04%,83.89%{transform:translate(48px,16px)}2.07%{transform:translate(48px,32px)}2.39%{transform:translate(80px,32px)}2.55%,51.67%{transform:translate(80px,48px)}2.71%{transform:translate(64px,48px)}3.35%{transform:translate(64px,112px)}3.67%,4.94%{transform:translate(32px,112px)}3.99%{transform:translate(32px,80px)}4.31%{transform:translate(0px,80px)}4.47%{transform:translate(0px,96px)}4.78%,82.3%{transform:translate(32px,96px)}6.22%{transform:translate(160px,112px)}6.54%{transform:translate(160px,80px)}6.7%{transform:translate(144px,80px)}7.02%,17.86%{transform:translate(144px,48px)}7.5%{transform:translate(192px,48px)}7.66%{transform:translate(192px,64px)}8.13%{transform:translate(240px,64px)}8.45%,14.83%,48.01%{transform:translate(240px,32px)}8.61%{transform:translate(256px,32px)}8.93%{transform:translate(256px,0px)}10.05%{transform:translate(368px,0px)}10.21%{transform:translate(368px,16px)}10.53%{transform:translate(400px,16px)}10.69%{transform:translate(400px,0px)}10.85%{transform:translate(384px,0px)}11.48%{transform:translate(384px,64px)}11.64%{transform:translate(368px,64px)}11.8%{transform:translate(368px,80px)}11.96%{transform:translate(352px,80px)}12.12%{transform:translate(352px,64px)}12.44%{transform:translate(320px,64px)}12.76%{transform:translate(320px,32px)}12.92%{transform:translate(304px,32px)}13.56%{transform:translate(304px,96px)}14.04%{transform:translate(256px,96px)}14.19%{transform:translate(256px,80px)}14.35%{transform:translate(240px,80px)}15.47%{transform:translate(176px,32px)}15.63%{transform:translate(176px,16px)}16.11%,17.07%,84.69%{transform:translate(128px,16px)}16.27%{transform:translate(128px,0px)}16.43%{transform:translate(112px,0px)}16.75%,46.09%,54.7%,98.41%{transform:translate(112px,32px)}16.91%{transform:translate(128px,32px)}17.38%,49.92%{transform:translate(160px,16px)}17.7%{transform:translate(160px,48px)}18.02%{transform:translate(144px,64px)}18.18%,97.93%{transform:translate(128px,64px)}18.34%,81.18%{transform:translate(128px,80px)}18.82%,49.12%{transform:translate(176px,80px)}18.98%,49.28%{transform:translate(176px,64px)}21.85%{transform:translate(464px,64px)}22.01%{transform:translate(464px,48px)}22.33%{transform:translate(496px,48px)}22.49%{transform:translate(496px,64px)}23.29%{transform:translate(576px,64px)}23.6%{transform:translate(576px,96px)}23.76%{transform:translate(592px,96px)}24.4%{transform:translate(592px,32px)}24.72%{transform:translate(560px,32px)}24.88%{transform:translate(560px,16px)}25.04%,70.65%{transform:translate(544px,16px)}25.2%,92.5%{transform:translate(544px,0px)}25.52%{transform:translate(512px,0px)}25.68%{transform:translate(512px,16px)}25.84%{transform:translate(496px,16px)}26%{transform:translate(496px,32px)}26.16%{transform:translate(512px,32px)}26.63%,60.45%{transform:translate(512px,80px)}26.79%,60.61%{transform:translate(528px,80px)}26.95%,59.17%,59.81%{transform:translate(528px,64px)}27.75%{transform:translate(608px,64px)}27.91%{transform:translate(608px,48px)}28.39%{transform:translate(656px,48px)}29.03%{transform:translate(656px,-16px)}29.51%{transform:translate(704px,-16px)}29.82%{transform:translate(704px,16px)}30.14%{transform:translate(736px,16px)}30.3%{transform:translate(736px,32px)}30.62%{transform:translate(768px,32px)}30.78%{transform:translate(768px,16px)}30.94%{transform:translate(784px,16px)}31.1%{transform:translate(784px,0px)}31.26%{transform:translate(768px,0px)}31.74%{transform:translate(768px,48px)}32.38%{transform:translate(704px,48px)}32.54%{transform:translate(704px,32px)}32.7%{transform:translate(688px,32px)}33.17%{transform:translate(688px,80px)}33.33%{transform:translate(672px,80px)}33.49%{transform:translate(672px,96px)}33.97%{transform:translate(720px,96px)}34.13%{transform:translate(720px,80px)}34.61%{transform:translate(768px,80px)}34.77%{transform:translate(768px,64px)}35.09%,37.64%,65.71%,74%{transform:translate(800px,64px)}35.57%{transform:translate(800px,16px)}36.04%{transform:translate(848px,16px)}36.68%{transform:translate(848px,80px)}36.84%,65.23%{transform:translate(832px,80px)}37%{transform:translate(832px,96px)}37.32%{transform:translate(800px,96px)}39.23%{transform:translate(640px,64px)}39.39%{transform:translate(640px,80px)}39.55%,69.22%{transform:translate(624px,80px)}39.87%{transform:translate(624px,112px)}45.14%{transform:translate(96px,112px)}45.77%{transform:translate(96px,48px)}45.93%,54.55%,98.25%{transform:translate(112px,48px)}46.41%{transform:translate(144px,32px)}46.73%{transform:translate(144px,0px)}47.37%{transform:translate(208px,0px)}47.53%{transform:translate(208px,16px)}47.85%{transform:translate(240px,16px)}48.48%{transform:translate(192px,32px)}48.96%{transform:translate(192px,80px)}49.44%,97.61%{transform:translate(160px,64px)}51.36%{transform:translate(48px,48px)}51.83%{transform:translate(80px,64px)}51.99%{transform:translate(64px,64px)}52.31%,98.88%{transform:translate(64px,32px)}52.95%{transform:translate(0px,32px)}53.27%{transform:translate(0px,64px)}53.43%{transform:translate(16px,64px)}53.59%{transform:translate(16px,48px)}58.37%{transform:translate(480px,32px)}58.69%{transform:translate(480px,64px)}59.33%{transform:translate(528px,48px)}59.49%{transform:translate(544px,48px)}59.65%{transform:translate(544px,64px)}60.13%{transform:translate(528px,96px)}60.29%{transform:translate(512px,96px)}61.24%{transform:translate(528px,16px)}62.04%{transform:translate(608px,16px)}62.2%{transform:translate(608px,0px)}64.27%{transform:translate(816px,0px)}64.75%{transform:translate(816px,48px)}64.91%{transform:translate(832px,48px)}65.55%{transform:translate(800px,80px)}67.46%{transform:translate(624px,64px)}67.78%{transform:translate(624px,32px)}67.94%{transform:translate(640px,32px)}68.1%{transform:translate(640px,48px)}68.26%{transform:translate(624px,48px)}68.74%{transform:translate(624px,96px)}68.9%{transform:translate(608px,96px)}69.06%{transform:translate(608px,80px)}69.86%{transform:translate(624px,16px)}70.81%{transform:translate(544px,32px)}73.52%{transform:translate(816px,32px)}73.84%{transform:translate(816px,64px)}74.16%{transform:translate(800px,48px)}80.86%,98.09%{transform:translate(128px,48px)}81.82%,86.92%{transform:translate(64px,80px)}81.98%{transform:translate(64px,96px)}83.25%{transform:translate(16px,16px)}83.41%{transform:translate(16px,0px)}83.73%{transform:translate(48px,0px)}85.49%{transform:translate(128px,96px)}85.65%{transform:translate(112px,96px)}85.96%{transform:translate(112px,64px)}86.6%{transform:translate(48px,64px)}86.76%{transform:translate(48px,80px)}87.72%{transform:translate(64px,0px)}93.46%{transform:translate(544px,96px)}97.29%{transform:translate(160px,96px)}99.36%{transform:translate(64px,-16px)}}.s.s1{transform:translate(16px,-16px);animation-name:s1}@keyframes s2{0%,99.84%{transform:translate(32px,-16px)}0.32%{transform:translate(0px,-16px)}0.64%{transform:translate(0px,16px)}0.8%{transform:translate(-16px,16px)}1.12%{transform:translate(-16px,48px)}1.59%{transform:translate(32px,48px)}1.91%,83.25%{transform:translate(32px,16px)}2.07%,51.2%,84.05%{transform:translate(48px,16px)}2.23%{transform:translate(48px,32px)}2.55%{transform:translate(80px,32px)}2.71%,51.83%{transform:translate(80px,48px)}2.87%{transform:translate(64px,48px)}3.51%{transform:translate(64px,112px)}3.83%,5.1%{transform:translate(32px,112px)}4.15%{transform:translate(32px,80px)}4.47%{transform:translate(0px,80px)}4.63%{transform:translate(0px,96px)}4.94%,82.46%{transform:translate(32px,96px)}6.38%{transform:translate(160px,112px)}6.7%{transform:translate(160px,80px)}6.86%{transform:translate(144px,80px)}7.18%,18.02%{transform:translate(144px,48px)}7.66%{transform:translate(192px,48px)}7.81%{transform:translate(192px,64px)}8.29%{transform:translate(240px,64px)}8.61%,14.99%,48.17%{transform:translate(240px,32px)}8.77%{transform:translate(256px,32px)}9.09%{transform:translate(256px,0px)}10.21%{transform:translate(368px,0px)}10.37%{transform:translate(368px,16px)}10.69%{transform:translate(400px,16px)}10.85%{transform:translate(400px,0px)}11%{transform:translate(384px,0px)}11.64%{transform:translate(384px,64px)}11.8%{transform:translate(368px,64px)}11.96%{transform:translate(368px,80px)}12.12%{transform:translate(352px,80px)}12.28%{transform:translate(352px,64px)}12.6%{transform:translate(320px,64px)}12.92%{transform:translate(320px,32px)}13.08%{transform:translate(304px,32px)}13.72%{transform:translate(304px,96px)}14.19%{transform:translate(256px,96px)}14.35%{transform:translate(256px,80px)}14.51%{transform:translate(240px,80px)}15.63%{transform:translate(176px,32px)}15.79%{transform:translate(176px,16px)}16.27%,17.22%,84.85%{transform:translate(128px,16px)}16.43%{transform:translate(128px,0px)}16.59%{transform:translate(112px,0px)}16.91%,46.25%,54.86%,98.56%{transform:translate(112px,32px)}17.07%{transform:translate(128px,32px)}17.54%,50.08%{transform:translate(160px,16px)}17.86%{transform:translate(160px,48px)}18.18%{transform:translate(144px,64px)}18.34%,98.09%{transform:translate(128px,64px)}18.5%,81.34%{transform:translate(128px,80px)}18.98%,49.28%{transform:translate(176px,80px)}19.14%,49.44%{transform:translate(176px,64px)}22.01%{transform:translate(464px,64px)}22.17%{transform:translate(464px,48px)}22.49%{transform:translate(496px,48px)}22.65%{transform:translate(496px,64px)}23.44%{transform:translate(576px,64px)}23.76%{transform:translate(576px,96px)}23.92%{transform:translate(592px,96px)}24.56%{transform:translate(592px,32px)}24.88%{transform:translate(560px,32px)}25.04%{transform:translate(560px,16px)}25.2%,70.81%{transform:translate(544px,16px)}25.36%,92.66%{transform:translate(544px,0px)}25.68%{transform:translate(512px,0px)}25.84%{transform:translate(512px,16px)}26%{transform:translate(496px,16px)}26.16%{transform:translate(496px,32px)}26.32%{transform:translate(512px,32px)}26.79%,60.61%{transform:translate(512px,80px)}26.95%,60.77%{transform:translate(528px,80px)}27.11%,59.33%,59.97%{transform:translate(528px,64px)}27.91%{transform:translate(608px,64px)}28.07%{transform:translate(608px,48px)}28.55%{transform:translate(656px,48px)}29.19%{transform:translate(656px,-16px)}29.67%{transform:translate(704px,-16px)}29.98%{transform:translate(704px,16px)}30.3%{transform:translate(736px,16px)}30.46%{transform:translate(736px,32px)}30.78%{transform:translate(768px,32px)}30.94%{transform:translate(768px,16px)}31.1%{transform:translate(784px,16px)}31.26%{transform:translate(784px,0px)}31.42%{transform:translate(768px,0px)}31.9%{transform:translate(768px,48px)}32.54%{transform:translate(704px,48px)}32.7%{transform:translate(704px,32px)}32.85%{transform:translate(688px,32px)}33.33%{transform:translate(688px,80px)}33.49%{transform:translate(672px,80px)}33.65%{transform:translate(672px,96px)}34.13%{transform:translate(720px,96px)}34.29%{transform:translate(720px,80px)}34.77%{transform:translate(768px,80px)}34.93%{transform:translate(768px,64px)}35.25%,37.8%,65.87%,74.16%{transform:translate(800px,64px)}35.73%{transform:translate(800px,16px)}36.2%{transform:translate(848px,16px)}36.84%{transform:translate(848px,80px)}37%,65.39%{transform:translate(832px,80px)}37.16%{transform:translate(832px,96px)}37.48%{transform:translate(800px,96px)}39.39%{transform:translate(640px,64px)}39.55%{transform:translate(640px,80px)}39.71%,69.38%{transform:translate(624px,80px)}40.03%{transform:translate(624px,112px)}45.3%{transform:translate(96px,112px)}45.93%{transform:translate(96px,48px)}46.09%,54.7%,98.41%{transform:translate(112px,48px)}46.57%{transform:translate(144px,32px)}46.89%{transform:translate(144px,0px)}47.53%{transform:translate(208px,0px)}47.69%{transform:translate(208px,16px)}48.01%{transform:translate(240px,16px)}48.64%{transform:translate(192px,32px)}49.12%{transform:translate(192px,80px)}49.6%,97.77%{transform:translate(160px,64px)}51.52%{transform:translate(48px,48px)}51.99%{transform:translate(80px,64px)}52.15%{transform:translate(64px,64px)}52.47%,99.04%{transform:translate(64px,32px)}53.11%{transform:translate(0px,32px)}53.43%{transform:translate(0px,64px)}53.59%{transform:translate(16px,64px)}53.75%{transform:translate(16px,48px)}58.53%{transform:translate(480px,32px)}58.85%{transform:translate(480px,64px)}59.49%{transform:translate(528px,48px)}59.65%{transform:translate(544px,48px)}59.81%{transform:translate(544px,64px)}60.29%{transform:translate(528px,96px)}60.45%{transform:translate(512px,96px)}61.4%{transform:translate(528px,16px)}62.2%{transform:translate(608px,16px)}62.36%{transform:translate(608px,0px)}64.43%{transform:translate(816px,0px)}64.91%{transform:translate(816px,48px)}65.07%{transform:translate(832px,48px)}65.71%{transform:translate(800px,80px)}67.62%{transform:translate(624px,64px)}67.94%{transform:translate(624px,32px)}68.1%{transform:translate(640px,32px)}68.26%{transform:translate(640px,48px)}68.42%{transform:translate(624px,48px)}68.9%{transform:translate(624px,96px)}69.06%{transform:translate(608px,96px)}69.22%{transform:translate(608px,80px)}70.02%{transform:translate(624px,16px)}70.97%{transform:translate(544px,32px)}73.68%{transform:translate(816px,32px)}74%{transform:translate(816px,64px)}74.32%{transform:translate(800px,48px)}81.02%,98.25%{transform:translate(128px,48px)}81.98%,87.08%{transform:translate(64px,80px)}82.14%{transform:translate(64px,96px)}83.41%{transform:translate(16px,16px)}83.57%{transform:translate(16px,0px)}83.89%{transform:translate(48px,0px)}85.65%{transform:translate(128px,96px)}85.81%{transform:translate(112px,96px)}86.12%{transform:translate(112px,64px)}86.76%{transform:translate(48px,64px)}86.92%{transform:translate(48px,80px)}87.88%{transform:translate(64px,0px)}93.62%{transform:translate(544px,96px)}97.45%{transform:translate(160px,96px)}99.52%{transform:translate(64px,-16px)}}.s.s2{transform:translate(32px,-16px);animation-name:s2}@keyframes s3{0%,99.84%{transform:translate(48px,-16px)}0.48%{transform:translate(0px,-16px)}0.8%{transform:translate(0px,16px)}0.96%{transform:translate(-16px,16px)}1.28%{transform:translate(-16px,48px)}1.75%{transform:translate(32px,48px)}2.07%,83.41%{transform:translate(32px,16px)}2.23%,51.36%,84.21%{transform:translate(48px,16px)}2.39%{transform:translate(48px,32px)}2.71%{transform:translate(80px,32px)}2.87%,51.99%{transform:translate(80px,48px)}3.03%{transform:translate(64px,48px)}3.67%{transform:translate(64px,112px)}3.99%,5.26%{transform:translate(32px,112px)}4.31%{transform:translate(32px,80px)}4.63%{transform:translate(0px,80px)}4.78%{transform:translate(0px,96px)}5.1%,82.62%{transform:translate(32px,96px)}6.54%{transform:translate(160px,112px)}6.86%{transform:translate(160px,80px)}7.02%{transform:translate(144px,80px)}7.34%,18.18%{transform:translate(144px,48px)}7.81%{transform:translate(192px,48px)}7.97%{transform:translate(192px,64px)}8.45%{transform:translate(240px,64px)}8.77%,15.15%,48.33%{transform:translate(240px,32px)}8.93%{transform:translate(256px,32px)}9.25%{transform:translate(256px,0px)}10.37%{transform:translate(368px,0px)}10.53%{transform:translate(368px,16px)}10.85%{transform:translate(400px,16px)}11%{transform:translate(400px,0px)}11.16%{transform:translate(384px,0px)}11.8%{transform:translate(384px,64px)}11.96%{transform:translate(368px,64px)}12.12%{transform:translate(368px,80px)}12.28%{transform:translate(352px,80px)}12.44%{transform:translate(352px,64px)}12.76%{transform:translate(320px,64px)}13.08%{transform:translate(320px,32px)}13.24%{transform:translate(304px,32px)}13.88%{transform:translate(304px,96px)}14.35%{transform:translate(256px,96px)}14.51%{transform:translate(256px,80px)}14.67%{transform:translate(240px,80px)}15.79%{transform:translate(176px,32px)}15.95%{transform:translate(176px,16px)}16.43%,17.38%,85.01%{transform:translate(128px,16px)}16.59%{transform:translate(128px,0px)}16.75%{transform:translate(112px,0px)}17.07%,46.41%,55.02%,98.72%{transform:translate(112px,32px)}17.22%{transform:translate(128px,32px)}17.7%,50.24%{transform:translate(160px,16px)}18.02%{transform:translate(160px,48px)}18.34%{transform:translate(144px,64px)}18.5%,98.25%{transform:translate(128px,64px)}18.66%,81.5%{transform:translate(128px,80px)}19.14%,49.44%{transform:translate(176px,80px)}19.3%,49.6%{transform:translate(176px,64px)}22.17%{transform:translate(464px,64px)}22.33%{transform:translate(464px,48px)}22.65%{transform:translate(496px,48px)}22.81%{transform:translate(496px,64px)}23.6%{transform:translate(576px,64px)}23.92%{transform:translate(576px,96px)}24.08%{transform:translate(592px,96px)}24.72%{transform:translate(592px,32px)}25.04%{transform:translate(560px,32px)}25.2%{transform:translate(560px,16px)}25.36%,70.97%{transform:translate(544px,16px)}25.52%,92.82%{transform:translate(544px,0px)}25.84%{transform:translate(512px,0px)}26%{transform:translate(512px,16px)}26.16%{transform:translate(496px,16px)}26.32%{transform:translate(496px,32px)}26.48%{transform:translate(512px,32px)}26.95%,60.77%{transform:translate(512px,80px)}27.11%,60.93%{transform:translate(528px,80px)}27.27%,59.49%,60.13%{transform:translate(528px,64px)}28.07%{transform:translate(608px,64px)}28.23%{transform:translate(608px,48px)}28.71%{transform:translate(656px,48px)}29.35%{transform:translate(656px,-16px)}29.82%{transform:translate(704px,-16px)}30.14%{transform:translate(704px,16px)}30.46%{transform:translate(736px,16px)}30.62%{transform:translate(736px,32px)}30.94%{transform:translate(768px,32px)}31.1%{transform:translate(768px,16px)}31.26%{transform:translate(784px,16px)}31.42%{transform:translate(784px,0px)}31.58%{transform:translate(768px,0px)}32.06%{transform:translate(768px,48px)}32.7%{transform:translate(704px,48px)}32.85%{transform:translate(704px,32px)}33.01%{transform:translate(688px,32px)}33.49%{transform:translate(688px,80px)}33.65%{transform:translate(672px,80px)}33.81%{transform:translate(672px,96px)}34.29%{transform:translate(720px,96px)}34.45%{transform:translate(720px,80px)}34.93%{transform:translate(768px,80px)}35.09%{transform:translate(768px,64px)}35.41%,37.96%,66.03%,74.32%{transform:translate(800px,64px)}35.89%{transform:translate(800px,16px)}36.36%{transform:translate(848px,16px)}37%{transform:translate(848px,80px)}37.16%,65.55%{transform:translate(832px,80px)}37.32%{transform:translate(832px,96px)}37.64%{transform:translate(800px,96px)}39.55%{transform:translate(640px,64px)}39.71%{transform:translate(640px,80px)}39.87%,69.54%{transform:translate(624px,80px)}40.19%{transform:translate(624px,112px)}45.45%{transform:translate(96px,112px)}46.09%{transform:translate(96px,48px)}46.25%,54.86%,98.56%{transform:translate(112px,48px)}46.73%{transform:translate(144px,32px)}47.05%{transform:translate(144px,0px)}47.69%{transform:translate(208px,0px)}47.85%{transform:translate(208px,16px)}48.17%{transform:translate(240px,16px)}48.8%{transform:translate(192px,32px)}49.28%{transform:translate(192px,80px)}49.76%,97.93%{transform:translate(160px,64px)}51.67%{transform:translate(48px,48px)}52.15%{transform:translate(80px,64px)}52.31%{transform:translate(64px,64px)}52.63%,99.2%{transform:translate(64px,32px)}53.27%{transform:translate(0px,32px)}53.59%{transform:translate(0px,64px)}53.75%{transform:translate(16px,64px)}53.91%{transform:translate(16px,48px)}58.69%{transform:translate(480px,32px)}59.01%{transform:translate(480px,64px)}59.65%{transform:translate(528px,48px)}59.81%{transform:translate(544px,48px)}59.97%{transform:translate(544px,64px)}60.45%{transform:translate(528px,96px)}60.61%{transform:translate(512px,96px)}61.56%{transform:translate(528px,16px)}62.36%{transform:translate(608px,16px)}62.52%{transform:translate(608px,0px)}64.59%{transform:translate(816px,0px)}65.07%{transform:translate(816px,48px)}65.23%{transform:translate(832px,48px)}65.87%{transform:translate(800px,80px)}67.78%{transform:translate(624px,64px)}68.1%{transform:translate(624px,32px)}68.26%{transform:translate(640px,32px)}68.42%{transform:translate(640px,48px)}68.58%{transform:translate(624px,48px)}69.06%{transform:translate(624px,96px)}69.22%{transform:translate(608px,96px)}69.38%{transform:translate(608px,80px)}70.18%{transform:translate(624px,16px)}71.13%{transform:translate(544px,32px)}73.84%{transform:translate(816px,32px)}74.16%{transform:translate(816px,64px)}74.48%{transform:translate(800px,48px)}81.18%,98.41%{transform:translate(128px,48px)}82.14%,87.24%{transform:translate(64px,80px)}82.3%{transform:translate(64px,96px)}83.57%{transform:translate(16px,16px)}83.73%{transform:translate(16px,0px)}84.05%{transform:translate(48px,0px)}85.81%{transform:translate(128px,96px)}85.96%{transform:translate(112px,96px)}86.28%{transform:translate(112px,64px)}86.92%{transform:translate(48px,64px)}87.08%{transform:translate(48px,80px)}88.04%{transform:translate(64px,0px)}93.78%{transform:translate(544px,96px)}97.61%{transform:translate(160px,96px)}99.68%{transform:translate(64px,-16px)}}.s.s3{transform:translate(48px,-16px);animation-name:s3}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c c0",
    x: 2,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1",
    x: 2,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2",
    x: 2,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3",
    x: 2,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "c c4",
    x: 2,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "c c5",
    x: 18,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "c c6",
    x: 18,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "c c7",
    x: 18,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "c c8",
    x: 18,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "c c9",
    x: 18,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "c ca",
    x: 34,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "c cb",
    x: 34,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "c cc",
    x: 34,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "c cd",
    x: 34,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "c ce",
    x: 34,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "c cf",
    x: 34,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "c cg",
    x: 50,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "c ch",
    x: 50,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "c ci",
    x: 50,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "c cj",
    x: 50,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "c ck",
    x: 50,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "c cl",
    x: 66,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "c cm",
    x: 66,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "c cn",
    x: 66,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "c co",
    x: 66,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "c cp",
    x: 66,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "c cq",
    x: 66,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "c cr",
    x: 82,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "c cs",
    x: 82,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "c ct",
    x: 82,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "c cu",
    x: 82,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "c cv",
    x: 82,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "c cw",
    x: 98,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "c cx",
    x: 98,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "c cy",
    x: 98,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "c cz",
    x: 114,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "c c10",
    x: 114,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "c c11",
    x: 114,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "c c12",
    x: 114,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "c c13",
    x: 130,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "c c14",
    x: 130,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "c c15",
    x: 130,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "c c16",
    x: 130,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "c c17",
    x: 130,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "c c18",
    x: 130,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "c c19",
    x: 130,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1a",
    x: 146,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1b",
    x: 146,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1c",
    x: 146,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1d",
    x: 146,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1e",
    x: 146,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1f",
    x: 162,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1g",
    x: 162,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1h",
    x: 178,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1i",
    x: 194,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1j",
    x: 194,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1k",
    x: 194,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1l",
    x: 210,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1m",
    x: 242,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1n",
    x: 242,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1o",
    x: 242,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1p",
    x: 242,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1q",
    x: 242,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1r",
    x: 258,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1s",
    x: 258,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1t",
    x: 274,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1u",
    x: 290,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1v",
    x: 306,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1w",
    x: 306,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1x",
    x: 322,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1y",
    x: 322,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1z",
    x: 338,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "c c20",
    x: 370,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "c c21",
    x: 370,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "c c22",
    x: 386,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "c c23",
    x: 402,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "c c24",
    x: 402,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "c c25",
    x: 482,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "c c26",
    x: 482,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "c c27",
    x: 498,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "c c28",
    x: 498,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "c c29",
    x: 498,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2a",
    x: 514,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2b",
    x: 514,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 530,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2c",
    x: 530,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 530,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2d",
    x: 530,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2e",
    x: 530,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2f",
    x: 530,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2g",
    x: 530,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 546,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2h",
    x: 546,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2i",
    x: 546,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2j",
    x: 546,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2k",
    x: 546,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2l",
    x: 546,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2m",
    x: 546,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2n",
    x: 562,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2o",
    x: 578,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2p",
    x: 578,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2q",
    x: 594,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2r",
    x: 594,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2s",
    x: 610,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2t",
    x: 610,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2u",
    x: 626,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2v",
    x: 626,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2w",
    x: 626,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2x",
    x: 626,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2y",
    x: 626,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2z",
    x: 626,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "c c30",
    x: 658,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "c c31",
    x: 658,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "c c32",
    x: 658,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "c c33",
    x: 658,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "c c34",
    x: 658,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "c c35",
    x: 674,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "c c36",
    x: 674,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "c c37",
    x: 674,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "c c38",
    x: 690,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "c c39",
    x: 690,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3a",
    x: 690,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3b",
    x: 690,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3c",
    x: 706,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3d",
    x: 706,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3e",
    x: 722,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3f",
    x: 722,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3g",
    x: 722,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3h",
    x: 722,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3i",
    x: 722,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3j",
    x: 738,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3k",
    x: 738,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3l",
    x: 738,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3m",
    x: 754,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3n",
    x: 754,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3o",
    x: 770,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3p",
    x: 770,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3q",
    x: 770,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3r",
    x: 770,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3s",
    x: 770,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3t",
    x: 770,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3u",
    x: 786,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3v",
    x: 786,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3w",
    x: 802,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3x",
    x: 818,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3y",
    x: 818,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3z",
    x: 818,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    className: "c c40",
    x: 818,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    className: "c c41",
    x: 818,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    className: "c c42",
    x: 818,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    className: "c c43",
    x: 834,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    className: "c c44",
    x: 834,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    className: "u u0",
    height: 12,
    width: 558.3,
    x: 0,
    y: 144
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    className: "u u1",
    height: 12,
    width: 188.4,
    x: 557.7,
    y: 144
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    className: "u u2",
    height: 12,
    width: 68.9,
    x: 745.6,
    y: 144
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    className: "u u3",
    height: 12,
    width: 34.7,
    x: 813.9,
    y: 144
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    className: "s s0",
    x: 0.8,
    y: 0.8,
    width: 14.4,
    height: 14.4,
    rx: 4.5,
    ry: 4.5
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    className: "s s1",
    x: 1.8,
    y: 1.8,
    width: 12.3,
    height: 12.3,
    rx: 4.1,
    ry: 4.1
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    className: "s s2",
    x: 2.6,
    y: 2.6,
    width: 10.8,
    height: 10.8,
    rx: 3.6,
    ry: 3.6
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    className: "s s3",
    x: 3,
    y: 3,
    width: 9.9,
    height: 9.9,
    rx: 3.3,
    ry: 3.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/snake.300c756531f08f5a36a9ae76869abaf7.svg";
export { ForwardRef as ReactComponent };